import { render } from "./CKEditor.vue?vue&type=template&id=0d29ae57"
import script from "./CKEditor.vue?vue&type=script&lang=js"
export * from "./CKEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/admin.23paskal.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__